module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/tablet-09f4fdadacf783015c672ad42be33492.svg";